export default "__VITE_ASSET__D85T1lg9__"